import { lazy, Suspense } from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';

import LoaderText from '../components/loader/LoaderText';
import BlankLayout from '../layout/BlankLayout';
import { NAVIGATE_AUTH, NAVIGATE_DASHBOARDS, USER_TYPE } from '../constant';
import AdminRoute from './AdminRoute';
import AuthRoute from './AuthRoute';
import GuestRoute from './GuestRoute';
import { SettingsProvider } from '../providers/SettingsProvider';
import { PermissionProvider } from '../providers/PermissionProvider';

const CommonDrawerComponent = lazy(() => import('../components/drawer'));
const CommonDialogComponent = lazy(() => import('../components/dialog'));

const AppRoute = () => {
    return (
        <PermissionProvider>
            <Suspense fallback={<BlankLayout><LoaderText /></BlankLayout>}>
                <Routes>
                    <Route path={`${NAVIGATE_AUTH.AUTH}/*`} element={<AuthRoute />}></Route>
                    <Route path={`${USER_TYPE.ADMIN}/*`} element={<SettingsProvider><AdminRoute /></SettingsProvider>}></Route>
                    <Route path={USER_TYPE.ADMIN} element={<Navigate to={NAVIGATE_DASHBOARDS.DASHBOARD_PAGE} />}></Route>
                    <Route path={`${NAVIGATE_AUTH.LOGIN}`} element={<Navigate to={NAVIGATE_AUTH.LOGIN_PAGE} />}></Route>
                    <Route path='/*' element={<GuestRoute />}></Route>
                </Routes>
            </Suspense>
            <Suspense fallback={null}>
                <CommonDrawerComponent />
                <CommonDialogComponent />
            </Suspense>
        </PermissionProvider>
    );
};

export default AppRoute;
